<template>
  <v-menu :close-on-click="true" :close-on-content-click="false" :offset-y="true">
    <template v-slot:activator="{ on }">
      <v-btn
        color="primary"
        v-on="on"
        small
        :style="!computedRows && 'background-color: lightgrey !important;'"
        :class="news_n?'pulseColor2':''">
        <v-icon >
          {{news_n?'notifications_active':'notifications'}}
        </v-icon>
      </v-btn>
    </template>
    <v-list class="notif_menu">
      <v-subheader>
        <h3 style="color:black">Notificaciones</h3>
      </v-subheader>

      <v-list-item-group v-model="selectedItem" color="primary">
        <v-list-item v-for="(item, index) in computedRows" :key="index" @click="go(item)" @mouseover="hover(item)">
          <v-list-item-avatar>
            <!-- <div class="ntf_check_icon">
              <v-icon big>check</v-icon>
            </div> -->
            <v-btn elevation="2" icon :style="`background-color: ${item.checked ?'#de5900':'grey'} !important`">
              <v-icon big style="color:white">check</v-icon>
            </v-btn>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-text="item.message" class="ntf_title"/>
            <v-list-item-subtitle v-text="item.timestamp"/>
            <hr>
          </v-list-item-content>
          
        </v-list-item>
      </v-list-item-group>
      <Navegation :rows_x_page="false"  :selectedItem.sync="navegation" :pageChange="pageChange" style="margin-top: 0;margin-bottom: 0"/>
    </v-list>
  </v-menu>
</template>

<script>
import CustomCrud from '@/components/crud/CustomCrud.js';
import navegation_compl from '../Navegation.js'

export default {
  mixins: [ CustomCrud, navegation_compl ],
  data() {
    return {
      news_n:0,
      pagination: true,
      gets_on_created:true,
      paths: {
        critical_asset:'ca/review',
        spare_part:'sp/review',
        issue_tracker:'home/issues',
        finding:'findings/review'
      }
    };
  },
  computed: {
    navegations(){ return this.$store.getters.navegations },
    news_name_all_computed() { return `news-${this.name_all_computed}`},
    news_request_status() {return this.requestStatus.find(f => f.name == this.news_name_all_computed)},
    news_request_status_rq() { return this.news_request_status.rq},
  },
  watch:{
    '$user'(u){ this.myRequestStatus.slot_key = `n-${u.id}` },
    //'news_request_status_rq'(v){ v.then && v.then(r => this.thenGetRows(r)) },
    'requestStatusRq'(v){ 
      if (v.then) {
        v.then(r => this.thenGetRows(r));
        /* cada vez q se actualizan las notifiaciones, se soliciata una consulta con solo las nuevas notificaciones */  
        if (this.user_id) this.get_news_n();
      }
    },
  },

  created(){
    this.requests.gets[this.name_all_computed]();
    this.navegations[this.name_all_computed].page_size = 5;

    if (this.user_id) {
      this.myRequestStatus.synchro_list = [];
      this.myRequestStatus.slot_key = `n-${this.user_id}`;
      this.myRequestStatus.active = true;
      this.get_news_n();
    }
  },
  updated() {
    this.$nextTick(()=>this.myRequestStatus.active = true)
  },
  methods: {
    hover(item){
      if (!item.checked) {
        item.checked = true;
        this.patch(item)
      }
    },
    get_news_n(){
      this.news_request_status.status = false;
      this.news_request_status.ticking = false;
      this.requests.gets[this.news_name_all_computed]({checked:false})
        .then(r => this.news_n = (r||{}).count || 0);
    },
    go(item) {
      /*
        0: Acción que requiere de revisión por parte del usuario. Debe redireccionar a revisar el elemento en cuestión.
        1: Notificación de solo lectura.
      */
      const {notification_type, notification_type_id, type} = item;
      if (notification_type && notification_type_id) {
        if (type === 0) {
          const path = `/${this.paths[notification_type]}/${notification_type_id}`;
          this.$router.push({ path});
        } else {
          if (notification_type == 'issue_tracker') {
            const path = `/${this.paths[notification_type]}`;
            this.$router.push({ path});
          }
        }
      } else {
        this.getError('Error en registro');
        this.dev_log({item});
      }
    }
  },
};
</script>

<style scoped>
/* .notif_menu{background-color: #dadada} */
.notif_menu .ntf_check_icon {
  border-radius: 30px;
  background-color: #de5900;
  padding: 3px;
}
.notif_menu .ntf_check_icon>i{ color: white }
.notif_menu .ntf_title {
  font-weight: bold;
}
.notif_menu .ntf_ttp{color: darkgray; }
</style>
